import { bindEvents, clamp, getRootOffset } from '../../assets/js/helpers';

import AnimationController from '../../assets/js/controller/animation';
import ResizeController from '../../assets/js/controller/resize';
import ScrollController from '../../assets/js/controller/scroll';

const selector = 'sticky';

export default class StickyElement {

	constructor(section) {
		this.el = {
			section,
			parent: section.closest('.sticky-parent') || section.parentNode
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// class variable groups
		this.bounds = {
			scrollMax: 0,
			scrollOverflow: 0,
			contentHeight: 0,
			winHeight: 0
		};

		this.controllers = {
			resize: null
		};

		this.offsets = {
			top: 0,
			scrollOverflow: 0
		};

		this.states = {
			lastPosition: 0,
			position: 0
		};

		// class variables

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
		this.measure();
		this.start();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.measure(); },
			resize: () => {}
		});
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	//

	start() {
		if (!this.animation) {
			this.animation = AnimationController.set({
				update: this.update.bind(this),
				render: this.render.bind(this)
			});
		}
	}

	pause() {
		if (this.animation) {
			AnimationController.clear(this.animation);
			this.animation = null;
		}
	}

	update() {
		let { position } = ScrollController;
		const min = 0;
		const max = this.bounds.scrollMax - this.bounds.contentHeight;

		if (this.bounds.scrollOverflow > 0) {
			const delta = this.states.position - this.states.lastPosition;
			this.offsets.scrollOverflow = clamp(this.offsets.scrollOverflow + delta, 0, this.bounds.scrollOverflow);
		} else {
			this.offsets.scrollOverflow = 0;
		}

		position = Math.round(position - this.offsets.top);
		position = clamp(position, min, max);

		if (position !== this.states.position) {
			this.states.lastPosition = this.states.position;
			this.states.position = position;
			return true;
		}
	}

	render() {
		this.el.section.style.transform = `translateY(${this.states.position - this.offsets.scrollOverflow}px)`;
	}

	measure() {
		this.offsets.top = parseInt(this.el.section.getAttribute('data-sticky-offset'), 10);
		if (isNaN(this.offsets.top)) this.offsets.top = getRootOffset(this.el.parent).top;

		this.bounds.scrollMax = this.el.parent.offsetHeight;
		this.bounds.winHeight = window.innerHeight;
		this.bounds.contentHeight = this.el.section.offsetHeight;
		this.bounds.scrollOverflow = this.bounds.contentHeight - this.bounds.winHeight;

		if (this.bounds.scrollOverflow > 0) this.bounds.scrollMax += this.bounds.scrollOverflow;
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
